<style scoped>
  .sidebar-container {
    border-right: 1px solid rgba(0,0,0,.1);
    color: rgba(0, 0, 0, 0.5);
  }

  @media (min-width: 768px) {
    .sidebar-container {
      margin-bottom: -45px;
    }
  }

  .title {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .section {
    color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }

  .section:hover, .section:active {
    text-decoration: none;
  }

  .item-container {
    margin-left: 7px;
    border-left: 2px solid #1d87b9;
  }

  .item {
    padding: 4px 8px;
    word-break: break-word;
  }
</style>

<template>
  <div v-if="showSidebar" class="sidebar-container">
    <b-row>
      <b-col>
        <h4 class="title pl-0 pt-3 pb-2">
          <i class="fa fa-bullseye fa-fw"></i> {{ title }}
        </h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row v-for="(item, index) in items" v-bind:key="item.stepName" class="mb-2">
          <b-col>
            <b-row>
              <b-col>
                <a class="px-0 text-nowrap w-100 section" v-b-toggle="`${index}`">
                  <font-awesome-icon
                    v-bind:icon="icons[item.stepName].name"
                    v-bind:class="icons[item.stepName].class"
                  />
                  <span class=""> {{ item.stepName }}</span>
                </a>
              </b-col>
            </b-row>
            <b-row v-if="item.fields">
              <b-col>
                <b-collapse :id="`${index}`"
                  class="item-container"
                  v-bind:visible="item.fields !== []"
                >
                  <b-row v-for="field in item.fields" v-bind:key="field.name"
                    class="item"
                  >
                    <b-col>
                      <strong>{{ field.name }}:</strong>
                      <span v-if="isCurrency(field.value)">
                        $ {{ currencyHandler(field.value) }}
                      </span>
                      <span v-else v-html="field.value"></span>
                    </b-col>
                  </b-row>
                </b-collapse>
            </b-col>
          </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import jshelper from '@/libs/helper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircle, faCheckCircle, faTimesCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';


library.add(faCircle, faCheckCircle, faTimesCircle, faMinusCircle);


export default {

  props: {
    showSidebar: Boolean,
    title: String,
    items: Array,
    currValidationResult: Object,
  },
  methods: {
    isCurrency(value) {
      if (typeof value === 'string' && value.length > 2) {
        return value.match(/^[+-]?[0-9]{1,4}(?:,?[0-9]{3}){1,3}$/g);
      }
      return false;
    },
    currencyHandler(value) {
      return jshelper.currency(value);
    },
  },
  computed: {
    validationResult() {
      return this.currValidationResult ?
        this.currValidationResult :
        { index: -1, isValid: false };
    },
    icons() {
      const icons = {};
      const successIcon = { name: 'check-circle', class: 'text-light-blue' };
      const failureIcon = { name: 'times-circle', class: 'text-danger' };
      const validationResult = this.validationResult;
      let idx = 0;

      Object.keys(this.items).forEach((key) => {
        let currIcon = { name: 'circle', class: '' };

        if (idx < validationResult.index) {
          currIcon = successIcon;
        } else if (idx === validationResult.index) {
          currIcon = validationResult.isValid ? successIcon : failureIcon;
        }

        icons[this.items[key].stepName] = currIcon;
        idx += 1;
      });

      return icons;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/base/sidebar/components/Sidebar.vue